import React, { useState, useRef, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import "./changePassword.scss";
import PasswordField from "../../jsx/components/fields/passwordField";
import PrimaryButton from "../../jsx/components/button/primaryButton";
import { useDispatch, useSelector } from "react-redux";
import {
  confirmPasswordValidation,

  passwordValidation,

} from "../../functions/validations";
import { changePassword } from "../../service/api/changePassword/changePassword";
import { btnChangePassword, btnNewPassword } from "../../dataBaseFile/alert";
import { passwordNotMatchText, validCurrentPasswordText, validPassword } from "../../dataBaseFile/error";
import { lblConfirmPasword, lblCurrentPassword, lblNewPasword, txtChangePassword } from "../../dataBaseFile/label";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";
import PasswordChecker from "../../component/passwordChecker/passwordChecker";


const ChangePassword = ({
  changePasswordTrigger,
  handleCloseChangePassword,
}) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isErrorButton, setIsErrorButton] = useState(false);
  const [isOldPassword, setIsOldPassword] = useState(false);
  const [isNewPassword, setIsNewPassword] = useState(false);
  const [isConfirmPassword, setIsConfirmPassword] = useState(false);

  const [loaderActive, setLoaderActive] = useState(true);

  const [responceMsg, setResponceMsg] = useState("");
  const [toasterType, setToasterType] = useState('');
  const [handleToaster, setHandleToaster] = useState(false);

  const [isFocusedOldPassword, setIsFocusedOldPassword] = useState(false);
  const [isFocusedNewPassword, setIsFocusedNewPassword] = useState(false);
  const [passwordErrorMsg, setPasswordErrorMsg] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (passwordValidation(oldPassword) && passwordValidation(newPassword)) {
      setLoaderActive(false);
      if (confirmPasswordValidation(newPassword, confirmPassword)) {
        let details = {
          user_id_ids: localStorage.getItem("user_id"),
          current_password: oldPassword,
          new_password: newPassword,
          confirm_password: confirmPassword,
        };
        dispatch(
          changePassword(
            details,
            (res) => {
              setResponceMsg(res.message);
              setOldPassword("");
              setNewPassword("");
              setConfirmPassword("");
              setLoaderActive(true);
              handleCloseChangePassword("success", res.message)
            },
            (res) => {
              setResponceMsg(res?.data.message);
              setLoaderActive(true);
              setIsErrorButton(true);

              setToasterType("error");

              setHandleToaster(true);
              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);

            }
          )
        );
      } else {
        setIsConfirmPassword(true);
      }
    } else {
      if (!passwordValidation(oldPassword)) {
        setIsOldPassword(true);
      }
      if (!passwordValidation(newPassword)) {
        setIsNewPassword(true);
        if (newPassword === "") {
          setPasswordErrorMsg(validPassword)
        } else {
          setPasswordErrorMsg("Please enter valid password.")
        }
      }
    }
  };


  function handleBlurPassword() {
    setIsFocusedOldPassword(false);
    if (!passwordValidation(oldPassword)) {
      setIsOldPassword(true);
    }
  }

  const handleOldPassword = (e) => {
    setIsOldPassword(false);
    setOldPassword(e.target.value);
  };

  const handleNewPassword = (e) => {
    setIsNewPassword(false);
    setNewPassword(e.target.value);
  };
  const handleConfirmPassword = (e) => {
    setIsConfirmPassword(false);
    setConfirmPassword(e.target.value);
  };

  function handleNewPasswordBlurCheck() {
    setIsFocusedNewPassword(false);
    if (!passwordValidation(newPassword)) {
      setIsNewPassword(true);
      if (newPassword === "") {
        setPasswordErrorMsg(validPassword)
      } else {
        setPasswordErrorMsg("Please enter valid password.")
      }
    }
  }

  function handleConfirmPasswordBlurCheck() {
    if (!confirmPasswordValidation(newPassword, confirmPassword)) {
      setIsConfirmPassword(true);
    }
  }




  return (
    <>
      {/* <!-- Modal --> */}
      <Modal
        className="fade"
        show={changePasswordTrigger}
        centered
      // onHide={handleCloseChangePassword}
      >
        {/* <Modal.Header style={{ borderBottom: "none" }}>
          <Modal.Title>{btnChangePassword}</Modal.Title>
          <Button
            variant=""
            className="btn-close btn-close-password"
            // onClick={() => setBasicModal(false)}
            onClick={() => handleCloseChangePassword("close")}></Button>
        </Modal.Header> */}

        <Modal.Body>
          <div className="row mx-0">
            <div className="col-12 px-0">

              <div className='mx-0 row text-black mb-4'>
                <div className='col-11 font-w600 fs-3 px-0 text-center'>
                  <span>
                    {btnChangePassword}
                  </span>
                </div>
                <div className='col-1 d-flex fs-4 justify-content-end px-0'>
                  <span onClick={() => handleCloseChangePassword("close")} className='cursor-pointer'>
                    <i className="bi bi-x-lg"></i>
                  </span>
                </div>
              </div>

              <div className="row mx-0">
                <div className="col-12 px-0">
                  <form onSubmit={(e) => handleSubmit(e)}>
                    <div className="row mx-0">
                      <div className="col-12 px-0">
                        <PasswordField
                          labelName={lblCurrentPassword}
                          onChange={handleOldPassword}
                          inputValue={oldPassword}
                          errorOccured={isOldPassword}
                          errorMessage={validCurrentPasswordText}
                          handleOnBlur={handleBlurPassword}
                          onFocus={() => setIsFocusedOldPassword(true)}
                        />
                      </div>
                    </div>


                    {/* {(isFocusedOldPassword || isOldPassword) &&
              <PasswordChecker password={oldPassword} />
            } */}

                    <div className="row mx-0">
                      <div className="col-12 px-0">
                        <PasswordField
                          labelName={lblNewPasword}
                          onChange={handleNewPassword}
                          inputValue={newPassword}
                          errorOccured={isNewPassword}
                          errorMessage={passwordErrorMsg}
                          handleOnBlur={handleNewPasswordBlurCheck}
                          onFocus={() => setIsFocusedNewPassword(true)}
                        />
                      </div>
                    </div>

                    <div className="row mx-0">
                      <div className="col-12 px-0">
                        {(isFocusedNewPassword || isNewPassword) &&
                          <PasswordChecker password={newPassword} />
                        }
                      </div>
                    </div>

                    <div className="row mx-0">
                      <div className="col-12 px-0">
                        <PasswordField
                          labelName={lblConfirmPasword}
                          onChange={handleConfirmPassword}
                          inputValue={confirmPassword}
                          errorOccured={isConfirmPassword}
                          errorMessage={passwordNotMatchText}
                          handleOnBlur={handleConfirmPasswordBlurCheck}
                        />
                      </div>
                    </div>

                    <div className="row mx-0">
                      <div className="col-12 px-0">
                        <PrimaryButton
                          buttonName={txtChangePassword}
                          onClick={handleSubmit}
                          isLoading={!loaderActive}
                          loadingMessage={"Changing password"}
                          style={{ width: '100%' }}
                        />
                      </div>
                    </div>
                  </form>

                </div>
              </div>
            </div>
          </div>
        </Modal.Body >
      </Modal >

      {handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />}

    </>
  );
};

export default ChangePassword;